export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  "left-stepper-form": () => import("/app/layouts/left-stepper-form.vue").then(m => m.default || m),
  "top-stepper-form": () => import("/app/layouts/top-stepper-form.vue").then(m => m.default || m)
}